import React from 'react';

interface UpdatedCustomIconProps {
  filled?: boolean;
}

const LinkedInIcon: React.FC<UpdatedCustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z'
      fill='#0B69C7'
    />
    <path
      d='M7.76283 6.36447C7.76309 6.63471 7.68318 6.89896 7.5332 7.12376C7.38323 7.34857 7.16993 7.52383 6.92031 7.62736C6.67069 7.7309 6.39597 7.75806 6.13091 7.7054C5.86585 7.65274 5.62237 7.52264 5.43128 7.33155C5.24019 7.14046 5.11009 6.89698 5.05743 6.63192C5.00477 6.36686 5.03193 6.09214 5.13547 5.84252C5.239 5.5929 5.41426 5.3796 5.63907 5.22963C5.86387 5.07965 6.12812 4.99974 6.39836 5C6.76013 5.00035 7.10699 5.14422 7.3628 5.40003C7.61861 5.65584 7.76248 6.0027 7.76283 6.36447Z'
      fill='white'
    />
    <path
      d='M7.1168 8.29883H5.67995C5.4932 8.29883 5.3418 8.45023 5.3418 8.63699V14.662C5.3418 14.8487 5.4932 15.0001 5.67995 15.0001H7.1168C7.30356 15.0001 7.45496 14.8487 7.45496 14.662V8.63699C7.45496 8.45023 7.30356 8.29883 7.1168 8.29883Z'
      fill='white'
    />
    <path
      d='M14.9668 11.7726V14.6897C14.9668 14.772 14.9341 14.851 14.8758 14.9092C14.8176 14.9675 14.7386 15.0002 14.6563 15.0002H13.1141C13.0318 15.0002 12.9528 14.9675 12.8946 14.9092C12.8363 14.851 12.8036 14.772 12.8036 14.6897V11.8634C12.8036 11.441 12.926 10.0212 11.701 10.0212C10.751 10.0212 10.5576 10.9976 10.5168 11.4357V14.6962C10.5151 14.777 10.482 14.8539 10.4245 14.9107C10.367 14.9674 10.2897 14.9995 10.2089 15.0002H8.71678C8.67595 15.0004 8.63549 14.9925 8.59774 14.9769C8.55999 14.9614 8.52569 14.9385 8.49682 14.9096C8.46795 14.8808 8.44508 14.8465 8.42954 14.8087C8.41399 14.771 8.40608 14.7305 8.40625 14.6897V8.61072C8.40608 8.56983 8.41398 8.52931 8.42951 8.49149C8.44504 8.45366 8.46789 8.41927 8.49674 8.3903C8.52559 8.36132 8.55988 8.33833 8.59764 8.32264C8.6354 8.30696 8.67589 8.29888 8.71678 8.29888H10.2089C10.2503 8.29818 10.2914 8.30573 10.3298 8.32109C10.3683 8.33645 10.4033 8.35931 10.4328 8.38833C10.4623 8.41736 10.4858 8.45198 10.5018 8.49016C10.5178 8.52834 10.526 8.56932 10.526 8.61072V9.13704C10.8786 8.61072 11.4023 8.2002 12.5168 8.2002C14.9813 8.19888 14.9668 10.5055 14.9668 11.7726Z'
      fill='white'
    />
  </svg>
);

export default LinkedInIcon;
